import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import './ActionItemDone.scss'
import { LuxIconBadge, LuxIcon, Color } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'

const ActionItemDone = (props) => {
    const componentClass = 'smart-new-activity-action-item-done'
    const { title } = props

    return (
        <div className={`${componentClass}`}>
            <span className="text">
                {title}
            </span>
            <div className={`${componentClass}__cta-container`}>
                <LuxIcon
                    icon="pencil"
                    onClick={() => props.onEdit()}
                    color={Color.BLUE}
                />
                <LuxIcon
                    icon="trash"
                    onClick={() => props.onRemove()}
                    color={Color.BLUE}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ActionItemDone)
